import { Grid } from "@mui/material";
import React from "react";
import Bouton from "../../../../components/Button/Bouton";
import UncontrolledInputField from "../../../../components/input/UncontrolledInputField";
import InputCheckbox from "../../../../components/inputCheckbox/InputCheckbox";
import UncontrolledSelect from "../../../../components/select/UncontrolledSelect";
import { construireListeParcours, construireListeStatuts } from "../helpers";

interface Props {
  classes?: any; // Surcharge de style CSS injecté par withStyles
  onChangeCritere(critere: string, value?: string | number | boolean): void;
  onRechercher(): void;
  initialValues: { [key: string]: any };
  utilisateurBesse?: boolean;
  idAdb?: number;
  isChargeClienteleBesse?: boolean;
  displayCandidatLocataire?: boolean;
}

function CriteresRecherche({
  initialValues,
  onChangeCritere,
  onRechercher,
  displayCandidatLocataire,
}: Props) {
  const handleUpdateCritere = (
    id?: string | number,
    value?: string | number
  ) => {
    if (value === "TOUS" && id) {
      onChangeCritere(id as string, "");
    } else if (id) {
      onChangeCritere(id as string, value);
    }
  };

  const handleUpdateCritereCheckBox = (id: string | number, event: boolean) => {
    onChangeCritere(id as string, event);
  };
  /**
   * Fonction permettant de déclencher la recherche.
   */
  const handleRechercher = () => {
    onRechercher();
  };

  return (
    <React.Fragment>
      <section>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          className={"formRechercherAdb fondGrisFonce"}
        >
          <Grid item xs={3}>
            <UncontrolledInputField
              id="refDossier"
              label="Référence location"
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            <UncontrolledInputField
              id="refMandat"
              label="Référence mandat"
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            <UncontrolledInputField
              id="ville"
              label="Ville"
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            {displayCandidatLocataire && (
              <UncontrolledSelect
                id="typeParcours"
                label="Type de parcours"
                options={construireListeParcours}
                handleChange={handleUpdateCritere}
              />
            )}
          </Grid>
          <Grid item xs={3}>
            <UncontrolledSelect
              id="statut"
              label="Statut"
              options={construireListeStatuts()}
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            <UncontrolledInputField
              id="nomLocataire"
              label="Nom du locataire"
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            <UncontrolledInputField
              id="prenomLocataire"
              label="Prénom du locataire"
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            <InputCheckbox
              input={{
                name: "gli",
                value: initialValues.gli,
                onBlur: () => {},
                onChange: () => {},
                onFocus: () => {},
              }}
              meta={{}}
              id="gli"
              name="gli"
              value={initialValues.gli}
              label="Garantie Li"
              onChangeValue={handleUpdateCritereCheckBox}
            />
          </Grid>
          <Grid item className={"bouton"} xs={6}>
            <Bouton
              label="Rechercher"
              variant="contained"
              color="primary"
              size="medium"
              onClick={handleRechercher}
            />
          </Grid>
        </Grid>
      </section>
    </React.Fragment>
  );
}

export default CriteresRecherche;
